import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { z } from 'zod';
import { DocsPage } from '../docs-view/index.js';

export const rootRoute = createRootRoute({});

const docsSearchSchema = z.object({
    path: z.string().optional(),
});

const docsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/',
    component: DocsPage,
    validateSearch: docsSearchSchema,
});

export const routeTree = rootRoute.addChildren([docsRoute]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}
